import { useTranslation } from 'react-i18next';

export default function ComparisonSection() {
  const { t } = useTranslation();

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-3">
            {t('comparison.title')}
          </h2>
          <p className="text-sm md:text-base text-foreground-500">
            {t('comparison.subtitle')}
          </p>
        </div>

        <div className="overflow-x-auto rounded-xl border border-background-200/70">
          <table className="w-full text-left">
            <thead>
              <tr className="bg-background-100">
                <th className="px-5 py-4 text-sm font-semibold text-foreground-800 whitespace-nowrap">{t('comparison.col1')}</th>
                <th className="px-5 py-4 text-sm font-semibold text-foreground-800 whitespace-nowrap text-center">{t('comparison.col2')}</th>
                <th className="px-5 py-4 text-sm font-semibold text-foreground-800 whitespace-nowrap text-center">{t('comparison.col3')}</th>
                <th className="px-5 py-4 text-sm font-semibold text-foreground-800 whitespace-nowrap text-center">{t('comparison.col4')}</th>
                <th className="px-5 py-4 text-sm font-semibold text-foreground-800 whitespace-nowrap text-center">{t('comparison.col5')}</th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-t border-background-200/50 bg-accent-50/30">
                <td className="px-5 py-4 text-sm font-semibold text-primary-600 whitespace-nowrap">{t('comparison.row1col1')}</td>
                <td className="px-5 py-4 text-sm text-foreground-700 text-center whitespace-nowrap">{t('comparison.row1col2')}</td>
                <td className="px-5 py-4 text-sm text-foreground-700 text-center whitespace-nowrap">{t('comparison.row1col3')}</td>
                <td className="px-5 py-4 text-sm text-foreground-700 text-center whitespace-nowrap">{t('comparison.row1col4')}</td>
                <td className="px-5 py-4 text-sm font-semibold text-accent-700 text-center whitespace-nowrap">{t('comparison.row1col5')}</td>
              </tr>
              <tr className="border-t border-background-200/50">
                <td className="px-5 py-4 text-sm text-foreground-700 whitespace-nowrap">{t('comparison.row2col1')}</td>
                <td className="px-5 py-4 text-sm text-foreground-500 text-center whitespace-nowrap">{t('comparison.row2col2')}</td>
                <td className="px-5 py-4 text-sm text-foreground-500 text-center whitespace-nowrap">{t('comparison.row2col3')}</td>
                <td className="px-5 py-4 text-sm text-foreground-500 text-center whitespace-nowrap">{t('comparison.row2col4')}</td>
                <td className="px-5 py-4 text-sm text-foreground-500 text-center whitespace-nowrap">{t('comparison.row2col5')}</td>
              </tr>
              <tr className="border-t border-background-200/50">
                <td className="px-5 py-4 text-sm text-foreground-700 whitespace-nowrap">{t('comparison.row3col1')}</td>
                <td className="px-5 py-4 text-sm text-foreground-500 text-center whitespace-nowrap">{t('comparison.row3col2')}</td>
                <td className="px-5 py-4 text-sm text-foreground-500 text-center whitespace-nowrap">{t('comparison.row3col3')}</td>
                <td className="px-5 py-4 text-sm text-foreground-500 text-center whitespace-nowrap">{t('comparison.row3col4')}</td>
                <td className="px-5 py-4 text-sm text-foreground-500 text-center whitespace-nowrap">{t('comparison.row3col5')}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}